<script lang="ts">
import { defineComponent, defineAsyncComponent, computed, PropType } from 'vue'

// vue-material-design-icons のアイコン名と動的 import のマップ（props の型定義のためモジュールスコープ）。
// 新しいアイコンを使う場合はここに 1 行追加する。
// @see https://github.com/robcresswell/vue-material-design-icons
// @see https://pictogrammers.com/library/mdi/
const materialIconMap = {
  Eye: () =>
    import('vue-material-design-icons/Eye.vue'),
  EyeOff: () =>
    import('vue-material-design-icons/EyeOff.vue'),
  FormatVerticalAlignTop: () =>
    import('vue-material-design-icons/FormatVerticalAlignTop.vue'),
  MessageReplyText: () =>
    import('vue-material-design-icons/MessageReplyText.vue'),
  Reply: () =>
    import('vue-material-design-icons/Reply.vue'),
  Calendar: () =>
    import('vue-material-design-icons/Calendar.vue'),
  CalendarBlankOutline: () =>
    import('vue-material-design-icons/CalendarBlankOutline.vue'),
  CalendarMonthOutline: () =>
    import('vue-material-design-icons/CalendarMonthOutline.vue'),
  ForumOutline: () =>
    import('vue-material-design-icons/ForumOutline.vue'),
  FileDocumentMultipleOutline: () =>
    import('vue-material-design-icons/FileDocumentMultipleOutline.vue'),
  LightbulbOnOutline: () =>
    import('vue-material-design-icons/LightbulbOnOutline.vue'),
  CardAccountDetailsOutline: () =>
    import('vue-material-design-icons/CardAccountDetailsOutline.vue'),
  VideoOutline: () =>
    import('vue-material-design-icons/VideoOutline.vue'),
  CheckCircleOutline: () =>
    import('vue-material-design-icons/CheckCircleOutline.vue'),
  ClockOutline: () =>
    import('vue-material-design-icons/ClockOutline.vue'),
  LinkVariant: () =>
    import('vue-material-design-icons/LinkVariant.vue'),
  FileDocumentOutline: () =>
    import('vue-material-design-icons/FileDocumentOutline.vue'),
  AlertCircleOutline: () =>
    import('vue-material-design-icons/AlertCircleOutline.vue'),
  EmailOutline: () =>
    import('vue-material-design-icons/EmailOutline.vue'),
} as const

export type MaterialIconName = keyof typeof materialIconMap

export default defineComponent({
  name: 'MaterialIcon',

  props: {
    name: {
      type: String as PropType<MaterialIconName>,
      required: true,
    },
  },

  setup(props) {
    const IconComponent = computed(() => {
      const loader = materialIconMap[props.name as MaterialIconName]
      if (!loader) return undefined
      return defineAsyncComponent(loader)
    })

    return {
      IconComponent,
    }
  }
})
</script>

<template>
  <component :is="IconComponent" />
</template>

<style lang="sass" scoped>
*
  display: block

// deep 修飾子で material icon のコンポーネントにスタイルを注入
::v-deep(svg)
  width: 100%
  height: 100%
  display: block
</style>
